module.exports = __webpack_public_path__ + "img/POA.749ae987.svg";